import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import './UploadedFile.css';

const UploadedFile = ({ file, i, values, setValues, name }) => {
    const handleRemoveFile = useCallback(() => {
        setValues(prev => ({
            ...prev,
            [name]: values[name].filter(item => item.path !== file.path),
        }));
    }, [name, setValues, values, file]);

    return (
        <li className="uploaded-file-wrap">
            <p>
                {i + 1}. {file.name}
            </p>
            <button type="button" onClick={handleRemoveFile} className="delete-file-btn">
                <span>+</span>
            </button>
        </li>
    );
};

UploadedFile.propTypes = {
    file: PropTypes.any.isRequired,
    i: PropTypes.number.isRequired,
    values: PropTypes.any.isRequired,
    setValues: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
};

export default UploadedFile;
